import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import Swiper from './components/Swiper';
import List from './components/List';
import Icon from 'components/UI/Icon';

import { MOBILE_KEY } from '@/constants/devices.js';
import useDeviceState from '@/hooks/useDeviceState';

import * as styles from './featuresMobile.module.scss';

// TODO: переделать
const FeaturesMobile = ({ data }) => {
  const deviceState = useDeviceState();

  return (
    <section className={classnames(styles.section)}>
      <div className={'cr-wrap'}>
        <div>
          <div className={classnames(styles.head)}>
            <p
              className={classnames(styles.subtitle, 'cr-subheader cr-text-3')}
            >
              {data.subtitle}
            </p>
            <h2 className={classnames('cr-h2')}>{data.title}</h2>
          </div>
          {deviceState === MOBILE_KEY ? (
            <Swiper data={data.list} />
          ) : (
            <List data={data.list} />
          )}

          <div className={classnames(styles.links)}>
            {data.links.map((link, i) => (
              <Link
                key={i}
                to={link.featuresLinkSrc.uri}
                className={classnames(
                  styles.links_item,
                  'cr-btn c-btn--icon cr-btn--icon-arrow cr-btn--wide cr-btn--large',
                  { 'cr-btn--icon-red-bg': i % 2 === 0 }
                )}
              >
                {link.featuresLinkText}
                <Icon name="corner-arrow-small-bold" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesMobile;
